import { CustomerTypes, VendorTypes } from '../Constants';

const getCustomerTypeContentKey = (customerType) => {
  return customerType === CustomerTypes.FUTUR ? '' : isComviqCustomer(customerType) ? 'comviq-' : 'b2b-';
};

export const isComviqCustomer = (customerType) => {
  return customerType === CustomerTypes.CBS || customerType === CustomerTypes.FUTUR_COMVIQ;
};

export const isBusinessCustomer = (customerType) => {
  return customerType === CustomerTypes.FUTUR_MICRO || customerType === CustomerTypes.MELODY;
};

export const isAppleDevice = () => {
  return window.__VENDOR__ === VendorTypes.APPLE;
};

export const isSamsungDevice = () => {
  return window.__VENDOR__ === VendorTypes.SAMSUNG;
};

export default getCustomerTypeContentKey;
